/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { first } from "lodash";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useData1 } from "../data/useData1";
import { useChart1 } from "../transformers/useChart1";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart, { Chartpoint } from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { yearToCropYearShort, useDictionaryItem, useParameter, useExport, useSubscriptionProviderContext } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export const ComponentChart1: React.FC<{ context: ContextReport1 }> = (props) => {
  const {
    actions: { setSource },
  } = useSubscriptionProviderContext();

  const context = props.context;
  const orderedCountriesIds = useHookSubscribe(null, context.orderedCountriesIds$);
  const populationByYearResult = useHookSubscribe(null, context.olapCountriesPopulation$);
  const selfSufficiencyByYearResult = useHookSubscribe(null, context.olapCountriesSelfSufficiency$);
  const consumtionByYearResult = useHookSubscribe(null, context.olapCountriesConsumtion$);

  const populationByYear = useData1(populationByYearResult);
  const selfSufficiencyByYear = useData1(selfSufficiencyByYearResult);
  const consumtionByYear = useData1(consumtionByYearResult);
  const chartData = useChart1({ populationByYear, selfSufficiencyByYear, consumtionByYear, orderedCountriesIds });

  const olapWorldPopulation = useHookSubscribe(null, context.olapWorldPopulation$);
  const worldStart = olapWorldPopulation?.data.rows[0]?.cells[0]?.value;
  const worldEnd = olapWorldPopulation?.data.rows[olapWorldPopulation!.data.rows.length - 1]?.cells[0]?.value;

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "calendar-population", first(parameterValues));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const source = useHookSubscribe(null, context.sources$);
  const exportBuilder = useExport();
  React.useEffect(() => {
    exportBuilder.set("source", source);
    setSource(source);
  }, [source]);

  const title = `World population: ${yearToCropYearShort(year - 4)}: ${
    worldStart ? `${worldStart.toFixed(0)} millions` : ""
  } - ${yearToCropYearShort(year)}: ${worldEnd ? `${worldEnd.toFixed(0)} millions` : ""}`;

  const handleChartHover = (point: Chartpoint | undefined) => {
    context.highlightData.next(point?.attributes || {});
  };
  if (window["exportMode"]) {
    window["exportReady"] = chartData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window["exportMode"] && (!chartData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>{title}</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <HighchartsChart data={chartData} onHover={handleChartHover} loader={<ComponentPreloader />} />
      <ComponentFootnote>*Self Sufficiency = The ratio of Production to Consumption</ComponentFootnote>
    </>
  );
};
